export default "__VITE_ASSET__MfCDN5i___"